<kt-requirement-radio-group
  [selected]="selectedAnswer"
  [question]="question"
  [visible]="visible"
  [options]="options"
  (selectedChange)="selectAnswer($event)"
>
</kt-requirement-radio-group>
